import React from 'react'
import { MegabarTransport } from '../../../transports/common/megabar-transport'
import { useTranslation } from '../../../hooks/locale'
import {
    MegarbarWrapper,
    MegaBarContainer,
    CountryList,
    MegaDropdownContainer,
    CountryTrigger,
    CountryDropdown,
    CountryName,
    SeoHref,
    ArrowIcon,
    RegionsList,
    RegionItem,
    DropdownRegionHeading,
} from './styles'

interface MegaBarProps {
    megabar: MegabarTransport
}

const MegaBar: React.FC<MegaBarProps> = ({ megabar }) => {
    const { t } = useTranslation()
    return (
        <MegarbarWrapper>
            <MegaBarContainer>
                <CountryList>
                    {megabar.countries.map(country => (
                        <MegaDropdownContainer key={`${country.name}`}>
                            <CountryTrigger>
                                <SeoHref href={country.link}>
                                    <CountryName>{country.name}</CountryName>
                                </SeoHref>
                                <ArrowIcon />
                            </CountryTrigger>

                            <CountryDropdown>
                                <DropdownRegionHeading>{t('popularPlaces')}</DropdownRegionHeading>
                                <RegionsList>
                                    {country.regions.map(region => (
                                        <SeoHref href={region.link} key={region.name}>
                                            <RegionItem>{region.name}</RegionItem>
                                        </SeoHref>
                                    ))}
                                </RegionsList>
                            </CountryDropdown>
                        </MegaDropdownContainer>
                    ))}
                </CountryList>
            </MegaBarContainer>
        </MegarbarWrapper>
    )
}

export default React.memo(MegaBar)
